import script from "./ParentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ParentDashboard.vue?vue&type=style&index=0&id=0f5d854b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5d854b"]])

export default __exports__